// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/faq.js'; import './autoload/foundation.js'; import './autoload/resources.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
import ScrollOut from 'scroll-out';

import './animations/about-us.js'; import './animations/key-principles.js'; import './animations/our-clients-list.js'; import './animations/our-clients.js'; import './animations/our-services.js'; // eslint-disable-line

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  $('a[href*="#"]').on('click', function (e) {
    const url = $(this).attr('href');

    if (url.startsWith('http')) return;

    const currentPath = window.location.pathname;
    const linkPath = url.split('#')[0];

    if (linkPath && linkPath !== '' && linkPath !== currentPath) return;

    e.preventDefault();

    const targetId = '#' + url.split('#')[1];
    const $target = $(targetId);

    $('body').removeClass('burger-is-open');
    $('.menu-icon').removeClass('is-active');

    setTimeout(function () {
      if ($target.length) {
        let offset = $('header').outerHeight() || 0;
        offset += window.innerWidth >= 1024 ? 0 : 0;

        $('html, body').animate(
          { scrollTop: $target.offset().top - offset },
          600
        );
      }
    }, 50);
  });

  if ($('.case-results__slider').length) {
    $('.case-results__slider').each(function () {
      $(this).slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        rows: 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              adaptiveHeight: true,
            },
          },
        ],
      });
    });
  }

  //  team members filter

  var $departments = $('.team__departments-item');
  var $members = $('.team__member');

  if ($departments.length && $members.length) {
    $departments.on('click', function () {
      var dept = $(this).data('dept');

      $departments.removeClass('active');
      $(this).addClass('active');
      console.log('DEPT CLICKED:', dept);

      $members.each(function () {
        console.log('MEMBER:', $(this).data('dept'));
      });

      var $inlineCtas = $('.team__cta--inline');

      // the extra tile of a filtered list is a clone, so remove it on every change
      $('.team__cta--filtered').remove();

      if (dept === 'all') {
        $members.show();
        $inlineCtas.show();
      } else {
        $inlineCtas.hide();
        var $visible = $members
          .hide()
          .filter(function () {
            var memberDepts = $(this).data('dept').split(' ');
            return memberDepts.includes(dept);
          })
          .show();

        // one recruitment tile in the middle of a filtered list (lists under 15 keep only the last tile)
        if ($visible.length >= 15 && $inlineCtas.length) {
          $inlineCtas
            .first()
            .clone()
            .removeClass('team__cta--inline')
            .addClass('team__cta--filtered')
            .show()
            .insertAfter($visible.eq(Math.ceil($visible.length / 2) - 1));
        }
      }
    });
  }

  // Clients Slider ==============

  const $clientsSlider = $('.clients__items');
  const $clientsTitles = $('.clients__titles-item');

  function updateTrackHeight($slider, slick) {
    const $currentSlide = $(slick.$slides[slick.currentSlide]);
    const slideHeight = $currentSlide.outerHeight(true);
    $slider.find('.slick-track').css('height', slideHeight + 'px');
  }

  if ($clientsSlider.length && $clientsTitles.length) {
    $clientsSlider
      .on('init', function (event, slick) {
        const cur = $(slick.$slides[slick.currentSlide]);
        const prev = cur.prev();
        const next = cur.next();

        prev.addClass('slick-sprev');
        next.addClass('slick-snext');
        cur.removeClass('slick-sprev slick-snext');

        slick.$prev = prev;
        slick.$next = next;

        $clientsTitles.removeClass('active-item');
        $clientsTitles.eq(slick.currentSlide).addClass('active-item');

        updateTrackHeight($clientsSlider, slick);
      })
      .on('setPosition', function (event, slick) {
        updateTrackHeight($clientsSlider, slick);
      })
      .on('afterChange', function (event, slick) {
        updateTrackHeight($clientsSlider, slick);
      })
      .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        const cur = $(slick.$slides[nextSlide]);

        slick.$prev.removeClass('slick-sprev');
        slick.$next.removeClass('slick-snext');

        const prev = cur.prev();
        const next = cur.next();

        prev.addClass('slick-sprev');
        next.addClass('slick-snext');

        slick.$prev = prev;
        slick.$next = next;

        cur.removeClass('slick-sprev slick-snext');

        $clientsTitles.removeClass('active-item');
        $clientsTitles.eq(nextSlide).addClass('active-item');
      });

    $clientsSlider.slick({
      speed: 300,
      vertical: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      focusOnSelect: true,
      infinite: false,
      slidesPerRow: 1,
      swipe: false,
      rows: 0,
    });

    $clientsTitles.on('click', function () {
      const index = $(this).index();
      $clientsSlider.slick('slickGoTo', index);
    });
  }

  // =======================

  // Why Us Section

  const $whyUsSection = $('.why-us');
  const $rows = $whyUsSection.length ? $whyUsSection.find('.why-us__row') : $();

  const minWidth = 1024;
  const maxWidth = 1440;

  function getPadding(value) {
    const w = $(window).width();
    if (w <= minWidth) return 0;
    if (w >= maxWidth) return value;
    return value * ((w - minWidth) / (maxWidth - minWidth));
  }

  function updatePaddings() {
    if ($rows.length <= 4) return;

    const totalRows = $rows.length;
    const maxPaddingLeft = 402;
    const maxPaddingRight = 334.109;
    const minPadding = 0;

    $rows.each(function (index) {
      const step = index / (totalRows - 1);
      const paddingLeft = getPadding(minPadding + step * maxPaddingLeft);
      const paddingRight = getPadding(maxPaddingRight - step * maxPaddingRight);

      $(this).css({
        paddingLeft: `${paddingLeft}px`,
        paddingRight: `${paddingRight < 0 ? 0 : paddingRight}px`,
      });
    });
  }

  if ($whyUsSection.length && $rows.length) {
    updatePaddings();
    $(window).on('resize', updatePaddings);
  }

  // Testimonials Slider ================

  const $sliderTestimonials = $('.js-testimonials-slider');
  const $logos = $('.js-testimonials-logos .testimonials__logo');

  if ($sliderTestimonials.length) {
    $sliderTestimonials.slick({
      arrows: true,
      dots: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true,
      fade: true,
      speed: 600,
      rows: 0,
    });

    if ($logos.length) {
      $logos.on('click', function () {
        const index = $(this).data('slide');
        $sliderTestimonials.slick('slickGoTo', index);
      });

      $sliderTestimonials.on(
        'afterChange',
        function (event, slick, currentSlide) {
          $logos.removeClass('active');
          $logos.eq(currentSlide).addClass('active');
        }
      );

      $logos.first().addClass('active');
    }
  }

  // =============================

  const $video = $('#home-bg-video');

  if ($video.length) {
    const video = $video.get(0);

    $(video).on('timeupdate', function () {
      if (video.duration - video.currentTime < 1) {
        $video.css('opacity', '0');
      }
    });

    $(video).on('seeked', function () {
      $video.css('opacity', '1');
    });
  }

  $('.menu-icon').on('click', function () {
    $('body').toggleClass('burger-is-open');
  });

  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    once: true,
    threshold: 0.5,
    // offset: function () {
    //   return window.innerHeight - 200;
    // },
    // once: true,
    onShown: function (element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function (i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function () {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  const $formWrapper = $('#footer-form');

  if ($formWrapper.length !== 0) {
    const observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const $oldScript = $(entry.target).find('script[data-url]');

            $oldScript.each(function () {
              const url = $(this).data('url');

              const newScript = document.createElement('script');
              newScript.src = url;
              newScript.defer = true;

              this.parentNode.replaceChild(newScript, this);
            });

            obs.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1,
      }
    );

    observer.observe($formWrapper[0]);
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});
